import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import styles from './CompanyManagerDashboardView.module.css';
import masaLogo from '../Assets/MasaLogo.png';

const CompanyManagerDashboardView = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  // Handlers for navigation
  const handleAddClick = () => {
    navigate('/product-management'); // Redirect to Product Management page
  };

  const handleRemoveClick = () => {
    navigate('/product-management'); // Redirect to Product Management page
  };

  const handleViewProductsClick = () => {
    navigate('/products-inventory'); // Redirect to Products Inventory page
  };

  const handleReturnClick = () => {
    navigate('/product-management'); // Redirect to Product Management page
  };

  const handleRequestClick = () => {
    navigate('/requests-management'); // Redirect to Product Management page
  };

  return (
    <main className={styles.dashboardView}>
      <header className={styles.header}>
        <img 
          loading="lazy" 
          src={masaLogo}
          className={styles.logo} 
          alt="Dashboard Logo" 
        />
        <h1 className={styles.dashboardTitle}>Company Manager Dashboard</h1>
      </header>
      <div className={styles.explanationText}>
        <p>
          Welcome to the <strong>company management dashboard</strong>. Use the buttons below to manage the inventory, process product returns, handle product requests, and view available products in the inventory.
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <button className={styles.addButton} onClick={handleAddClick}>
          <i className="fas fa-plus"></i> Add
        </button>
        <button className={styles.removeButton} onClick={handleRemoveClick}>
          <i className="fas fa-minus"></i> Remove
        </button>
        <button className={styles.viewButton} onClick={handleViewProductsClick}>
          <i className="fas fa-eye"></i> View Products
        </button>
        <button className={styles.returnButton} onClick={handleReturnClick}>
          <i className="fas fa-undo"></i> Return
        </button>
        <button className={styles.requestButton} onClick={handleRequestClick}>
          <i className="fas fa-envelope"></i> Requests
        </button>
      </div>
    </main>
  );
};

export default CompanyManagerDashboardView;
